import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";

import {
  getAdminUserInfo,
  getAffiliateInfo,
  getUserInformation,
  subscriptionsStripeGetPlans,
} from "../../store/middleware";
import { setBuyPlans } from "../../store/slices/generics.slice";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { setStudentPlan } from "../../store/slices/student.slice";
import { SCButtonAddInput } from "../../components/Buttons/styles";

import { DowngradeUpgradeStyles } from "./Styles";

function DowngradeUpgrade({
  plans,
  setPlans,
  studentPlan,
  setOpenPlans,
  setChangeType,
  setSelectedPlanId,
  setShowManagePlan,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [planosValores, setPlanosValores] = useState({ menorValor: 0, maiorValor: 0 });

  const loadInfos = async () => {
    const { country_code } = await dispatch(getUserInformation());
    const isAffiliate = await dispatch(getAffiliateInfo(user?.id));
    const countryURL = country_code === "BR" ? "BR" : "US";
    const affiliateId = studentPlan?.studentPlanPayments[0]?.affiliateId;

    const responseUserInfo = await dispatch(getAdminUserInfo(`studentManagement/getbyuser/${user?.id}`));
    const cpn = decryptIfEncrypted(responseUserInfo.result.items[0]?.cpnCode ?? "");

    const exclusiveFor = isAffiliate
      ? "affiliate"
      : studentPlan?.length === 0 || studentPlan[0]?.studentPlanPayments?.length === 0
      ? "partner"
      : affiliateId !== null
      ? "affiliate"
      : "website_stripe";

    const response = await dispatch(subscriptionsStripeGetPlans("", "", countryURL, exclusiveFor, true, null, cpn));

    const newPlans = response.map((plan) => {
      return {
        ...plan,
        totalClasses: plan.unlimited ? 9999 : plan.totalClasses,
        currency: countryURL,
      };
    });

    const minValores = newPlans.filter((plan) => !plan.unlimited).map(({ totalClasses }) => totalClasses);
    const menorValor = Math.min(...minValores);

    const maxValores = newPlans.map(({ totalClasses }) => totalClasses);
    const maiorValor = Math.max(...maxValores);

    setPlanosValores({ menorValor, maiorValor });

    setPlans(newPlans);
    // dispatch(setBuyPlans(newPlans));
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const loadPlans = async (change) => {
    if (change === "upgrade") {
      setPlans(plans.filter((plan) => plan.totalClasses > studentPlan?.plan.totalClasses || plan.unlimited));
      dispatch(
        setBuyPlans(plans.filter((plan) => plan.totalClasses > studentPlan?.plan.totalClasses || plan.unlimited)),
      );
    }
    if (change === "downgrade") {
      if (studentPlan.plan.unlimited) {
        setPlans(plans.filter((plan) => !plan.unlimited));
        dispatch(setBuyPlans(plans.filter((plan) => !plan.unlimited)));
      } else {
        setPlans(plans.filter((plan) => !plan.unlimited && plan.totalClasses < studentPlan?.plan.totalClasses));

        dispatch(
          setBuyPlans(plans.filter((plan) => !plan.unlimited && plan.totalClasses < studentPlan?.plan.totalClasses)),
        );
      }
    }
  };

  const handleDowngrade = async (totalClasses, studentPlanId, studentPlan) => {
    if (typeof totalClasses === "boolean") {
      setPlans(plans.filter((plan) => !plan.unlimited));
      setSelectedPlanId(studentPlanId);
      setChangeType("downgrade");
      loadPlans("downgrade");
      return;
    }
    setChangeType("downgrade");
    setSelectedPlanId(studentPlanId);
    await dispatch(setStudentPlan(studentPlan));
    loadPlans("downgrade");
  };

  const handleUpgrade = async (totalClasses, studentPlanId, studentPlan) => {
    setChangeType("upgrade");
    setSelectedPlanId(studentPlanId);
    await dispatch(setStudentPlan(studentPlan));
    loadPlans("upgrade");
  };

  return (
    <DowngradeUpgradeStyles>
      {studentPlan.plan.unlimited ? (
        <SCButtonAddInput
          ml="12px"
          background="#004fff"
          color="#fff"
          onClick={() => {
            setOpenPlans(true);
            setShowManagePlan(false);
            handleDowngrade(
              studentPlan.plan.totalClasses === 0 ? studentPlan.plan.unlimited : studentPlan.plan.totalClasses,
              studentPlan.studentPlanPayments[0]?.studentPlanId,
              studentPlan.studentPlanPayments[0],
            );
          }}
          value="Search"
          style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}
        >
          <FaArrowDown />
          {t("PLAN_DOWNGRADE")}
        </SCButtonAddInput>
      ) : (
        <>
          {studentPlan.plan.totalClasses > planosValores?.menorValor && (
            <SCButtonAddInput
              ml="12px"
              background="#004fff"
              color="#fff"
              onClick={() => {
                setOpenPlans(true);
                setShowManagePlan(false);
                handleDowngrade(
                  studentPlan.plan.totalClasses === 0 ? studentPlan.plan.unlimited : studentPlan.plan.totalClasses,
                  studentPlan.studentPlanPayments[0]?.studentPlanId,
                  studentPlan.studentPlanPayments[0],
                );
              }}
              value="Search"
              style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}
            >
              <FaArrowDown />
              {t("PLAN_DOWNGRADE")}
            </SCButtonAddInput>
          )}

          {studentPlan.plan.totalClasses < planosValores?.maiorValor && (
            <SCButtonAddInput
              ml="12px"
              background="#004fff"
              color="#fff"
              onClick={() => {
                setOpenPlans(true);
                handleUpgrade(
                  studentPlan.plan.totalClasses === 0 ? studentPlan.plan.unlimited : studentPlan.plan.totalClasses,
                  studentPlan.studentPlanPayments[0]?.studentPlanId,
                  studentPlan.studentPlanPayments[0],
                );
              }}
              value="Search"
              style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}
            >
              <FaArrowUp />
              {t("PLAN_UPGRADE")}
            </SCButtonAddInput>
          )}
        </>
      )}
    </DowngradeUpgradeStyles>
  );
}

export default DowngradeUpgrade;
